import axios from "axios";

import { LocalStorageKeys } from "@sso/constant";
import { localStorageHelper } from "@sso/utils";

export const apiInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "X-ClientId": process.env.REACT_APP_CLIENT_ID || "",
  },
});

apiInstance.interceptors.request.use(
  config => {
    const token = localStorageHelper.getItem<string>(LocalStorageKeys.TOKEN);
    if (token && config.headers) {
      config.headers["X-Security-Token"] = token;
    }
    return config;
  },
  error => Promise.reject(error),
);
